export const USER_LOGIN = "USER/LOGIN";
export const USRE_INFO = "USER/INFO";
